const { Fragment, useState } = wp.element
const { BlockControls } = wp.blockEditor
const { Button } = wp.components
const { registerPlugin } = wp.plugins

const isLivePreview =
  SUBlockEditorSettings.isLivePreview === true ||
  SUBlockEditorSettings.isLivePreview === 1 ||
  SUBlockEditorSettings.isLivePreview === '1' ||
  SUBlockEditorSettings.isLivePreview === 'true'

const shortcodeIcon = (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M10,3L3,3L3,21L10,21L10,17L7,17L7,7L10,7L10,3ZM14,3L21,3L21,21L14,21L14,17L17,17L17,7L14,7L14,3Z" />
  </svg>
)

const LivePreviewPopover = () => {
  return (
    <div
      className="su-live-preview-popover"
      role="status"
      style={{
        position: 'absolute',
        top: 'calc(100% + 12px)',
        left: '50%',
        zIndex: 100000,
        width: '300px',
        maxWidth: 'calc(100vw - 32px)',
        padding: '16px 18px',
        borderRadius: '6px',
        background: '#0b66c3',
        boxShadow: '0 14px 36px rgba(11, 102, 195, 0.28)',
        boxSizing: 'border-box',
        color: '#fff',
        fontSize: '16px',
        lineHeight: '1.45',
        textAlign: 'left',
        transform: 'translateX(-50%)',
        whiteSpace: 'normal'
      }}
    >
      <span
        aria-hidden="true"
        style={{
          position: 'absolute',
          top: '-7px',
          left: '50%',
          width: '14px',
          height: '14px',
          background: '#0b66c3',
          transform: 'translateX(-50%) rotate(45deg)'
        }}
      />
      <strong
        style={{
          display: 'block',
          marginBottom: '6px',
          color: '#fff',
          fontSize: '18px',
          lineHeight: '1.3'
        }}
      >
        {SUBlockEditorL10n.livePreviewTitle}
      </strong>
      <span>{SUBlockEditorL10n.livePreviewDescription}</span>
    </div>
  )
}

const withInsertShortcodeButton = BlockEdit => {
  return props => {
    if (SUBlockEditorSettings.supportedBlocks.indexOf(props.name) === -1) {
      return <BlockEdit {...props} />
    }

    return (
      <Fragment>
        <BlockEdit {...props} />
        <BlockControls
          controls={[
            {
              icon: shortcodeIcon,
              title: SUBlockEditorL10n.insertShortcode,
              onClick: () => {
                window.SUG.App.insert('block', { props: props })
              }
            }
          ]}
        />
      </Fragment>
    )
  }
}


const insertShortcodeHandler = () => {
  const { dispatch, select } = wp.data
  const { createBlock } = wp.blocks
  const blockEditor = select('core/block-editor')
  const selectedBlockId = blockEditor.getSelectedBlockClientId()
  const selectedBlock = selectedBlockId ? blockEditor.getBlock(selectedBlockId) : null

  if (selectedBlock) {
    const blockType = wp.blocks.getBlockType(selectedBlock.name)

    if (blockType && blockType.attributes && (blockType.attributes.content || selectedBlock.name === 'core/shortcode')) {
      window.SUG.App.insert('block', { props: {
        name: selectedBlock.name,
        attributes: selectedBlock.attributes,
        setAttributes: (newAttrs) => {
          dispatch('core/block-editor').updateBlockAttributes(selectedBlock.clientId, newAttrs)
        }
      }})
      return
    }
  }

  const shortcodeBlock = createBlock('core/shortcode', { text: '' })
  const insertionIndex = blockEditor.getBlockInsertionPoint()
  dispatch('core/block-editor').insertBlock(shortcodeBlock, insertionIndex.index, insertionIndex.rootClientId)
  dispatch('core/block-editor').selectBlock(shortcodeBlock.clientId)

  setTimeout(() => {
    window.SUG.App.insert('block', { props: {
      name: 'core/shortcode',
      attributes: { text: '' },
      setAttributes: (newAttrs) => {
        dispatch('core/block-editor').updateBlockAttributes(shortcodeBlock.clientId, newAttrs)
      }
    }})
  }, 100)
}

const HeaderToolbarButton = () => {
  const [isPopoverVisible, setPopoverVisible] = useState(isLivePreview)

  const onClick = () => {
    setPopoverVisible(false)
    insertShortcodeHandler()
  }

  return (
    <Fragment>
      <Button
        icon={shortcodeIcon}
        label={SUBlockEditorL10n.insertShortcode}
        onClick={onClick}
        className="su-insert-shortcode-button"
      />
      {isPopoverVisible && <LivePreviewPopover />}
    </Fragment>
  )
}

const ShortcodeUltimateToolbar = () => {
  return (
    <wp.editPost.PluginMoreMenuItem
      icon={shortcodeIcon}
      onClick={insertShortcodeHandler}
    >
      {SUBlockEditorL10n.insertShortcode}
    </wp.editPost.PluginMoreMenuItem>
  )
}

registerPlugin('shortcodes-ultimate-toolbar', {
  render: ShortcodeUltimateToolbar
})

if (SUBlockEditorSettings.showToolbarButton === 'on') {
  wp.domReady(() => {
    const toolbarSelector = '.edit-post-header-toolbar, .editor-header__toolbar'

    const addButtonToToolbar = () => {
      const toolbar = document.querySelector(toolbarSelector)

      if (toolbar && !document.querySelector('.su-insert-shortcode-button')) {
        const buttonContainer = document.createElement('div')
        buttonContainer.className = 'su-insert-shortcode-button-container'
        buttonContainer.style.display = 'inline-flex'
        buttonContainer.style.alignItems = 'center'
        buttonContainer.style.marginLeft = '8px'
        buttonContainer.style.position = 'relative'

        toolbar.appendChild(buttonContainer)

        wp.element.render(
          wp.element.createElement(HeaderToolbarButton),
          buttonContainer
        )
      }
    }

    addButtonToToolbar()

    const observer = new MutationObserver(() => {
      addButtonToToolbar()
    })

    observer.observe(document.body, {
      childList: true,
      subtree: true
    })
  })
}

if (SUBlockEditorSettings.showBlockControlsButton === 'on') {
  wp.hooks.addFilter(
    'editor.BlockEdit',
    'shortcodes-ultimate/with-insert-shortcode-button',
    withInsertShortcodeButton
  )
}
